import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

const tooltipBody = (
  <Box sx={{ maxWidth: 320, p: 0.5 }}>
    <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
      Adding links
    </Typography>
    <Typography variant="body2" sx={{ mb: 0.75 }}>
      Wrap the text you want shown in square brackets, then the URL in parentheses:
    </Typography>
    <Typography
      variant="body2"
      component="code"
      sx={{
        display: 'block',
        px: 0.75,
        py: 0.25,
        mb: 0.75,
        borderRadius: 0.5,
        bgcolor: 'rgba(0,0,0,0.25)',
        fontFamily: 'monospace',
      }}
    >
      [Tate Modern](https://tate.org.uk/retro-2024)
    </Typography>
    <Typography variant="caption" sx={{ display: 'block', opacity: 0.85 }}>
      Only http:// and https:// links are allowed. Anything else is saved as plain text.
    </Typography>
  </Box>
);

export const MarkdownLinkHelp: React.FC = () => (
  <Tooltip
    title={tooltipBody}
    arrow
    enterTouchDelay={0}
    leaveTouchDelay={4000}
    placement="top"
  >
    <IconButton
      size="small"
      aria-label="How to add links"
      onClick={(event) => event.stopPropagation()}
      onFocus={(event) => event.stopPropagation()}
      sx={{ ml: 0.5, color: 'text.secondary' }}
    >
      <HelpOutline fontSize="small" />
    </IconButton>
  </Tooltip>
);
